/* Assets/footer-custom.js */

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.js-accordion');

  accordions.forEach(acc => {
    const title = acc.querySelector('.footer-title');

    title.addEventListener('click', () => {
      // Solo su mobile (< 990px)
      if (window.innerWidth > 990) return;

      const isOpen = acc.classList.contains('is-open');

      // Chiudi gli altri (opzionale, per pulizia)
      accordions.forEach(other => other.classList.remove('is-open'));

      if (!isOpen) {
        acc.classList.add('is-open');
      }
    });
  });
});